import SenderLock from './SenderLock';

export default class PendingEvents {
  constructor() {
    this.events = [];
  }

  storeEvent(event) {
    this.events.push(event);
  }

  releaseEvents() {
    SenderLock.unlockSending();
    this.events.forEach(event => event.send());
  }
}